import { userData, passwordData } from "../pages/Registration/type";
import { API_URL } from "../utils/constants";
import axios, { AxiosError } from "axios";

export const RegisterAsPartner = async (payload: userData) => {
  try {
    const response = await axios.post(`${API_URL}/merchants/partner`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data; // Return the data on success
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Failed to register as partner"
      );
    }
    throw new Error("An unexpected error occurred");
  }
};

export const changePassword = async (payload: passwordData) => {
  try {
    const response = await axios.patch(
      `${API_URL}/auth/change-password`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response?.data;
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      if (axios.isAxiosError(error) && error.response?.status === 400) {
        console.log("it's axios");
        // Throw the error to trigger onError in TanStack Query
        throw Error(
          error.response?.data?.message || "Failed to change password"
        );
      }
      // Throw unexpected errors as well
      throw new Error("An unexpected error occurred");
    }
  }
};
